import {
  FETCH_TICKETS,
  FETCH_TICKETS_FAILURE,
  FETCH_TICKETS_SUCCESS,
  SET_PASSENGERS_COUNTS,
  SET_TICKETS_INFO,
} from './constants';

const ticketsInitialState = {
  byConnectionInfo: {},
};

export const serializeConnectionInfo = (ticketType, connectionId1, connectionId2) =>
  `${ticketType},${connectionId1},${connectionId2}`;

const ticketsReducer = (state = ticketsInitialState, action) => {
  switch (action.type) {
    case FETCH_TICKETS:
      return {
        ...state,
        byConnectionInfo: {
          ...state.byConnectionInfo,
          [serializeConnectionInfo(
            action.payload.ticketType,
            action.payload.connectionId1,
            action.payload.connectionId2,
          )]: {
            isFetching: true,
            tickets: [],
          },
        },
      };
    case FETCH_TICKETS_SUCCESS:
      return {
        ...state,
        byConnectionInfo: {
          ...state.byConnectionInfo,
          [serializeConnectionInfo(
            action.payload.ticketType,
            action.payload.connectionId1,
            action.payload.connectionId2,
          )]: {
            isFetching: false,
            tickets: action.payload.tickets,
          },
        },
      };
    case FETCH_TICKETS_FAILURE:
      return {
        ...state,
        byConnectionInfo: {
          ...state.byConnectionInfo,
          [serializeConnectionInfo(
            action.payload.ticketType,
            action.payload.connectionId1,
            action.payload.connectionId2,
          )]: {
            isFetching: false,
            tickets: [],
          },
        },
      };
    case SET_PASSENGERS_COUNTS:
      return {
        ...state,
        counts: { ...action.payload },
        types: { ...state.types },
        error: null,
        isFetching: false,
      };
    case SET_TICKETS_INFO:
      return {
        ...state,
        ticketsInfo: [...action.payload],
      };
    default:
      return state;
  }
};

export default ticketsReducer;



// WEBPACK FOOTER //
// ./src/containers/Passengers/reducer.js